import { Dropdown } from "react-bootstrap";
import useClientConfig from "../hooks/clientConfigHook";
import useConfigStatuses from "../hooks/configStatusHook";
import useCredentials from "../hooks/credentialsHook";
import { useUpsertSetting } from "../hooks/settingsHooks";
import PropTypes from 'prop-types'

const ConfigStatusButton = ({ uuid, style }) => {
    const credentials = useCredentials();
    const upsertSetting = useUpsertSetting();
    const clientConfig = useClientConfig();
    const statuses = useConfigStatuses();

    const currentStatus = statuses.find(s => s.value === clientConfig.configStatus?.[uuid]);
    const disabled = !credentials.access.hasFull('administrator');

    return !clientConfig.configDetails?.complete && <Dropdown>
        <Dropdown.Toggle variant="default" disabled={disabled} style={{ ...style, backgroundColor: currentStatus?.color }}>
            {currentStatus?.label}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ zIndex: 10 }}>
            {!disabled && statuses.filter(s => s !== currentStatus).map(s => <Dropdown.Item key={s.value} style={{ backgroundColor: s.color }} onClick={() => upsertSetting(null, 'configStatus', { ...clientConfig.configStatus, [uuid]: s.value })}>{s.label}</Dropdown.Item>)}
        </Dropdown.Menu>
    </Dropdown>
}
ConfigStatusButton.propTypes = {
    uuid: PropTypes.string.isRequired,
    stype: PropTypes.object
}

export default ConfigStatusButton;